<!--body-->
<div class="d-flex h-100">
  <!--menu-->
  <div class="sidepanel"
       [class.open]="!collapsed"
       (click)="collapsed = true">
    <button class="btn btn-primary-outline border-0 toggle d-inline d-sm-none mt-2 mx-2"
            (click)="collapsed = false; $event.stopPropagation()">
      <fa-icon [icon]="['fas', 'bars']"
               size="sm"></fa-icon>
    </button>
    <div class="menu shadow bg-primary overflow-y-auto d-flex flex-column h-100"
         [class.hidden]="collapsed">
      <div class="ps-3 py-3 border-top border-bottom border-primary">
        <era-brand></era-brand>
      </div>
      <div class="flex-grow-1">
        <era-menus [menus]="menus$ | async"></era-menus>
      </div>
      <div class="border-top border-bottom border-primary">
        <a class="btn btn-primary"
           href="https://rcksftdata001.blob.core.windows.net/user-manual/rocksoft_user_manual-1.0.0_redacted.pdf"
           role="button">
          <fa-icon [icon]="['fas', 'info-circle']"
                   size="sm"></fa-icon>
        </a>
      </div>
    </div>
  </div>
  
  <div class="flex-grow-1 overflow-y-auto">
    <router-outlet></router-outlet>
  </div>
</div>